import { useMemo } from "react";
import { useMeCache } from "~/queries/useMe";
import { USER_PERMISSIONS } from "~served/configs";

export const usePermissionFilters = () => {
	const { data: me } = useMeCache();
	const permissionsDictionary: Record<keyof typeof USER_PERMISSIONS, boolean> =
		useMemo(() => {
			const dictionary = Object.keys(USER_PERMISSIONS).reduce(
				(acc, key) => {
					acc[key] = false;
					return acc;
				},
				{} as Record<keyof typeof USER_PERMISSIONS, boolean>,
			);

			if (me) {
				me.permissions.forEach((permission) => {
					dictionary[permission] = true;
				});
			}

			return dictionary;
		}, [me]);

	return permissionsDictionary;
};
